import { render, staticRenderFns } from "./integralShopping.vue?vue&type=template&id=1ece7442&scoped=true"
import script from "./integralShopping.vue?vue&type=script&lang=js"
export * from "./integralShopping.vue?vue&type=script&lang=js"
import style0 from "./integralShopping.vue?vue&type=style&index=0&id=1ece7442&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ece7442",
  null
  
)

export default component.exports